import thunk from 'redux-thunk';

import {
  loanApplicationSingleSaveMiddleware,
  pendingChangesAuthorsHeaderMiddleware,
} from '../loanApplications/middlewares';

const middlewares = [
  thunk,
  loanApplicationSingleSaveMiddleware,
  pendingChangesAuthorsHeaderMiddleware,
];

export default middlewares;
